export enum StorageEnum {
  USER = '_u',
  TOKEN = '_t',
}
